module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Leave-Credit/leave-credit-sanction/leave-credit-sanction-grid/leave-credit-sanction-grid.component.css
// module id = ./src/app/hrms/Leave-Credit/leave-credit-sanction/leave-credit-sanction-grid/leave-credit-sanction-grid.component.css
// module chunks = main